'use strict';

angular.module('dash.pdfPreview', [])

.controller('PdfPreviewController', require('./PdfPreviewController'))
.directive('pdfPreview', require('./PdfPreviewDirective'))

// Service subclasses for Dash and Manager states
.service('ManagerPdfPreviewService', require('./services/ManagerPdfPreviewService'))
.service('DashPdfPreviewService', require('./services/DashPdfPreviewService'))

// Flux Actions and Store
.factory('PdfPreviewActions', require('./PdfPreviewActions'))
.factory('PdfPreviewStore', require('./PdfPreviewStore'))

// Bind store to actions through init method
.run(['PdfPreviewStore', function (PdfPreviewStore) {
  PdfPreviewStore.init();
}]);


// WEBPACK FOOTER //
// ./src/app/shared/pdfPreview/index.js